import type { PropsWithChildren } from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { tv } from "tailwind-variants";

import { focusRing, icons } from "@/ui";
import { cannabis101 } from "../page";

const mobileTabMenuVariants = tv({
  base: "overflow-hidden rounded-card border border-line-strong",
});

type MobileTabMenuProps = {
  selectedIndex: number;
  setSelectedIndex: (index: number) => void;
  className?: string;
};

export const MobileTabMenu = ({
  className,
  selectedIndex,
  setSelectedIndex,
}: PropsWithChildren<MobileTabMenuProps>) => {
  return (
    <Menu as="div" className={mobileTabMenuVariants({ className })}>
      <MenuButton
        className={`flex min-h-14 w-full cursor-pointer items-center justify-between gap-3 bg-surface py-3 pr-3 pl-4 font-semibold text-accent transition-colors hover:bg-surface-hover ${focusRing}`}
      >
        {({ open }) => {
          return (
            <>
              <span>{cannabis101[selectedIndex].title}</span>
              {open ? (
                <icons.ChevronUpIcon className="size-6 text-content" />
              ) : (
                <icons.ChevronDownIcon className="size-6 text-content" />
              )}
            </>
          );
        }}
      </MenuButton>

      <MenuItems className="w-full border-t border-line bg-surface">
        {cannabis101
          .filter((_, index) => {
            return index !== selectedIndex;
          })
          .map((tab, index) => {
            return (
              <MenuItem key={index}>
                <button
                  className={`flex min-h-12 w-full cursor-pointer items-center px-4 py-3 text-left text-content-secondary transition-colors hover:bg-surface-hover hover:text-accent ${focusRing}`}
                  onClick={() => {
                    return setSelectedIndex(cannabis101.indexOf(tab));
                  }}
                  type="button"
                >
                  {tab.title}
                </button>
              </MenuItem>
            );
          })}
      </MenuItems>
    </Menu>
  );
};
